import React, { Component } from 'react';
import Spinner from 'react-spinkit';

import './botMessage.css'

class BotMessage extends Component {

  state = {
    content: 'spinner'
  }

  calculateTimeout() {
    const commentLength = this.props.comment ? this.props.comment.length : 0
    const questionLength = this.props.question ? this.props.question.length : 0

    const timeout = (commentLength + questionLength) * 10

    if (timeout < 300) {
      return 800
    } else {
      return timeout
    }
  }

  componentDidMount() {

    const timeout = this.calculateTimeout()

    setTimeout(() => {
      this.setState({content: 'message'})

      this.props.scroll()

    }, timeout)

    this.props.triggerNext(this.calculateTimeout()*2.5)
  }

  render() {

    return(
      <div className="bot-row">

        <div className="bot-avatar">
          {this.props.botName.substring(0,1)}
        </div>

        <div className="bot-message drop-shadow">
          {this.state.content === "spinner" &&
            <Spinner name="ball-pulse-sync" fadeIn="none" className="bot-spinner"/>
          }

          {this.state.content === "message" &&
            <div>

              {this.props.comment && <p>{this.props.comment}</p>}

                {this.props.comment && this.props.question && <div style={{height: '15px'}}/>}

              {this.props.question && <h3>{this.props.question}</h3>}

                {this.props.question && this.props.addon && <div style={{height: '15px'}}/>}

              {this.props.addon && <h5>{this.props.addon}</h5>}

              {this.props.button &&
                <div style={{margin: '20px 0px 10px 0px'}}>
                  {this.props.button}
                </div>
              }

            </div>
          }
        </div>
      </div>
    )
  }
}

export default BotMessage
